<template>
  <bdg-input-template :name="name" :required="required">
    <multi-add
      :empty-state-message="emptyStateMessage"
      :add-item-text="addItemText"
      @removed="$emit('removed', $event)"
      v-model="computedValue"
    />
  </bdg-input-template>
</template>

<script>
import BdgInputTemplate from "./BdgInputTemplate";
import MultiAdd from "./MultiAdd";

export default {
  name: "BdgMultiAdd",
  extends: BdgInputTemplate,
  components: { MultiAdd, BdgInputTemplate },
  props: {
    emptyStateMessage: String,
    addItemText: String,
    value: Array
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>

<style scoped></style>
